export const SCANNER_DATA = "SCANNER_DATA";
export const JOB_DATA = "JOB_DATA";
export const CLEAR_JOB_DATA = "CLEAR_JOB_DATA";